import React from "react";
import styled from "styled-components";
import GlassCard from "../GlassCard/GlassCard";

const SpacedGlassCard = ({ children, className, ...props }) => {
  return (
    <StyledSpacedGlassCard className={className} {...props}>
      {children}
    </StyledSpacedGlassCard>
  );
};

const StyledSpacedGlassCard = styled(GlassCard)`
  margin-bottom: 32px;

  @media screen and (max-width: 768px) {
    margin-bottom: 24px;
  }
`;

export default SpacedGlassCard;
